import Video from 'show-page/models/video';
import { action, computed, observable } from 'mobx';
import { CLIP } from 'common/constants/video-type';
import { CLIPS_PER_PAGE, VIDEOS_API_ENDPOINT, VIDEOS_API_FIELDS, VIDEOS_API_SORT } from 'show-page/constants/config';
import { find } from 'lodash';


class VideoSearch {
    @observable isLoading = false;
    @observable query;
    @observable total;
    @observable videos = [];

    constructor(store, query) {
        this.store = store;
        this.query = query;
    }

    destroy() {
        this.store = null;
    }

    search() {
        this.setLoading(true);
        return fetch(this.searchUrl)
            .then(response => response.json())
            .then(json => {
                this.setTotal(json.count);
                (json.data || []).forEach(video => this.addVideo(video));
                this.setLoading(false);
            })
            .catch(() => this.setLoading(false));
    }


    /*=======================================
    =            Computed Values            =
    =======================================*/

    @computed get canLoadMore() {
        return isNaN(this.total) || this.videos.length < this.total;
    }

    @computed get searchUrl() {
        const query = encodeURIComponent(this.query);
        const q = [
            '_exists_:season_number',
            `type:"${CLIP}"`,
            `collection_id:${this.store.collection.id}`,
            `(title:${query}+OR+tags:${query})`,
            'NOT+tags:404'
        ];
        const params = [
            `q=${q.join('+AND+')}`,
            `sort=${VIDEOS_API_SORT}`,
            `fields=${VIDEOS_API_FIELDS}`,
            `size=${CLIPS_PER_PAGE}`,
            `from=${this.videos.length}`
        ];
        return `${VIDEOS_API_ENDPOINT}?${params.join('&')}`;
    }


    /*===============================
    =            Actions            =
    ===============================*/

    @action addVideo = (props) => {
        if (!props || !find(this.videos, { id: props.id })) {
            this.videos.push(new Video(this.store, props));
        }
    };

    @action setLoading = (isLoading) => {
        this.isLoading = !!isLoading;
    };

    @action setTotal = (total) => {
        this.total = parseInt(total, 10) || 0;
    };

}


export default VideoSearch;



/** WEBPACK FOOTER **
 ** ./src/show-page/models/video-search.js
 **/